import { render, staticRenderFns } from "./remarkDialog.vue?vue&type=template&id=455e97e4&"
import script from "./remarkDialog.vue?vue&type=script&lang=js&"
export * from "./remarkDialog.vue?vue&type=script&lang=js&"
import style0 from "./remarkDialog.vue?vue&type=style&index=0&id=455e97e4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports